module.exports = __webpack_public_path__ + "static/media/ios-star.4e4ace47.svg";